
import { env } from "@/lib/env";

const PLANE_LOADING_GIF = `${env.ASSETS_BASE_URL}/assets/branding/page-loader-1-unscreen.gif`;

interface PlaneLoadingScreenProps {
  label?: string;
  fullscreen?: boolean;
}

export default function PlaneLoadingScreen({
  label = "Loading…",
  fullscreen = true,
}: PlaneLoadingScreenProps) {
  return (
    <div
      className={
        fullscreen
          ? "flex items-center justify-center h-screen"
          : "flex items-center justify-center p-6"
      }
    >
      <div className="flex flex-col items-center gap-3">
        <img
          src={PLANE_LOADING_GIF}
          alt="Loading"
          className="
            object-contain
            w-32 h-32
            sm:w-40 sm:h-40
            max-w-[50vw] max-h-[50vw]
          "
        />
        {label && (
          <p className="text-sm text-gray-500 text-center">{label}</p>
        )}
      </div>
    </div>
  );
}
